var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Email",
    transform: "translate(-27.555 -10.336)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_3",
    "data-name": "Rectangle 3",
    transform: "translate(27.555 10.336)",
    fill: "#f0f1f4",
    stroke: "#cad0d9",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 8,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 63,
    height: 63,
    rx: 7.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Union_303",
    "data-name": "Union 303",
    d: "M7161.663,20159.531a3.664,3.664,0,0,1-3.665-3.664v-14.932a3.662,3.662,0,0,1,3.665-3.658h20.676a3.657,3.657,0,0,1,3.659,3.658v14.932a3.663,3.663,0,0,1-3.659,3.664Zm-1.509-3.664a1.5,1.5,0,0,0,1.509,1.508h20.676a1.508,1.508,0,0,0,1.508-1.508v-11.395l-10.629,5.693a2.54,2.54,0,0,1-2.439,0l-10.624-5.693Zm.324-13.838,11.241,6.027a.608.608,0,0,0,.562,0l11.236-6.027a1.017,1.017,0,0,1,.329-.107v-.986a1.508,1.508,0,0,0-1.508-1.5h-20.676a1.505,1.505,0,0,0-1.509,1.5v.988A.994.994,0,0,1,7160.478,20142.029Z",
    transform: "translate(-7112.444 -20105.941)",
    fill: "#304669",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmail);
export default __webpack_public_path__ + "static/media/icon_email.4a983a352091982ed70f356bce76421e.svg";
export { ForwardRef as ReactComponent };